import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import useComponentOverride from "../../hooks/useComponentOverride.js";
import useStyleOverride from "../../hooks/useStyleOverride.js";
import baseStyles from "./styles.module.css.js";
import { InfoBox } from '@react-google-maps/api';
import clsx from 'clsx';
export var Arrow = _ref => {
  var {
    size = 8,
    base,
    length,
    arrowOffset = '25%',
    direction = 'up',
    tipOffset = '0.5',
    fill = '#fff'
  } = _ref;
  var styles = useStyleOverride('GoogleMaps/Popover', baseStyles);
  var width = direction === 'up' || direction === 'down' ? base !== null && base !== void 0 ? base : size * 2 : length !== null && length !== void 0 ? length : size;
  var height = direction === 'up' || direction === 'down' ? length !== null && length !== void 0 ? length : size : base !== null && base !== void 0 ? base : size * 2;
  var points = direction === 'up' ? [[0, 1], [tipOffset, 0], [1, 1]] : direction === 'down' ? [[0, 0], [tipOffset, 1], [1, 0]] : direction === 'left' ? [[1, 0], [0, tipOffset], [1, 1]] : [[0, 0], [1, tipOffset], [0, 1]];
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.arrow, direction === 'up' && styles.directionUp, direction === 'right' && styles.directionRight, direction === 'down' && styles.directionDown, direction === 'left' && styles.directionLeft),
    style: {
      '--fill': fill,
      '--arrowWidth': "".concat(width, "px"),
      '--arrowHeight': "".concat(height, "px"),
      '--tipOffset': tipOffset,
      '--arrowOffset': arrowOffset
    }
  }, /*#__PURE__*/React.createElement("svg", {
    preserveAspectRatio: "none",
    viewBox: "0,0 1,1"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: points.map(c => c.join(',')).join(' ')
  })));
};
var ensureUnit = value => typeof value === 'string' ? value : "".concat(value, "px");
var noop = e => {
  e.preventDefault();
  e.stopPropagation();
};
export var Popover = _ref2 => {
  var _arrowProps$direction;
  var {
    result,
    position,
    xOffset = '-10%',
    yOffset = '8px',
    showHeading = true,
    showCloseButton = true,
    onDismiss,
    disabledCorners = {},
    showArrow = true,
    arrowProps: _arrowProps
  } = _ref2;
  var styles = useStyleOverride('GoogleMaps/Popover', baseStyles);
  var [PopoverContent, PopoverHeading] = useComponentOverride('GoogleMaps/Popover/PopoverContent', 'GoogleMaps/Popover/PopoverHeading');
  var direction = (_arrowProps$direction = _arrowProps === null || _arrowProps === void 0 ? void 0 : _arrowProps.direction) !== null && _arrowProps$direction !== void 0 ? _arrowProps$direction : 'up';
  var arrowProps = _objectSpread({
    arrowOffset: direction === 'up' || direction === 'down' ? "calc(-1* ".concat(ensureUnit(xOffset), ")") : "calc(-1* ".concat(ensureUnit(yOffset), ")")
  }, _arrowProps !== null && _arrowProps !== void 0 ? _arrowProps : {});
  return /*#__PURE__*/React.createElement(InfoBox, {
    position: position !== null && position !== void 0 ? position : new google.maps.LatLng(result.lat, result.lng),
    options: {
      pane: 'overlayMouseTarget',
      disableAutoPan: true
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.PopoverContainer
  }, /*#__PURE__*/React.createElement("div", {
    ref: _ref3 => _ref3 && google.maps.OverlayView.preventMapHitsAndGesturesFrom(_ref3),
    className: clsx(styles.Popover, disabledCorners.topLeft && styles.disableTopLeft, disabledCorners.topRight && styles.disableTopRight, disabledCorners.bottomRight && styles.disableBottomRight, disabledCorners.bottomLeft && styles.disableBottomLeft),
    style: {
      '--popoverOffsetX': ensureUnit(xOffset),
      '--popoverOffsetY': ensureUnit(yOffset)
    }
  }, showArrow && /*#__PURE__*/React.createElement(Arrow, arrowProps), /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, showHeading && /*#__PURE__*/React.createElement(PopoverHeading, {
    result: result,
    onDismiss: onDismiss,
    showCloseButton: showCloseButton
  }), /*#__PURE__*/React.createElement(PopoverContent, {
    result: result
  })))));
};
export default Popover;
//# sourceMappingURL=index.js.map